import { render, staticRenderFns } from "./GStudentAllCompetencyComparison.vue?vue&type=template&id=9e14bd9e&scoped=true&"
import script from "./GStudentAllCompetencyComparison.vue?vue&type=script&lang=ts&"
export * from "./GStudentAllCompetencyComparison.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e14bd9e",
  null
  
)

export default component.exports